import { Fragment } from "react";

import useNTGroupAdd from "./UseNTGroupAdd";

import NTGroupAddForm from "../components/forms/groupAdd/NTGroupAddForm";
import NTGroupsLoadingModal from "../components/dialogs/loading/NTGroupsLoadingModal";

import Headings from "@usas/ui-web/components/headings/Headings";

import { SAVING_MSG } from "@usas/ui-web/utils/Constants";

const NTGroupAdd = () => {
  const {
    isSaving,
    onSubmitInfoForm,
    onBackClicked
  } = useNTGroupAdd();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>National Team Group Add</Headings.H3>
        </div>
      </div>
      <NTGroupAddForm
        onSubmitFormCallback={onSubmitInfoForm}
        onSecondaryButtonClicked={onBackClicked} />
      <NTGroupsLoadingModal
        isLoading={isSaving}
        loadingMessage={SAVING_MSG} />
    </Fragment>
  );
};

export default NTGroupAdd;